import {getToken, setToken, removeToken, setRefresh} from '../../utils/auth'
import jwt_decode from 'jwt-decode';
import authApi from '@/api/auth'

const state = () => {
    const token = getToken();
    try {
        const data = jwt_decode(token);
        return {
            token,
            username: data['name'],
            userid: data['user_id'],
            roles: data.authorities,
            menus: data.adminMenus
        }
    } catch (e) {
        return {
            token: '',
            username: '',
            userid: '',
            roles: [],
            menus: []
        }
    }
}

const actions = {
    login: ({commit, dispatch}, payload) => {
        commit('CLEAR');

        return authApi.login(payload.loginId, payload.loginPw).then((data) => {
            dispatch('error/hide', {}, {root:true});
            const access = jwt_decode(data.access_token);
            // if (access.authorities && access.authorities.indexOf('관리자')>=0) {  
            if (access.adminMenus && access.adminMenus.length > 0) {
                commit('SET_TOKEN', data.access_token);
                commit('SET_USERNAME', data.name);
                commit('SET_REFRESH', data.refresh_token);
                commit('SET_USERID', data.user_id);
                commit('SET_ROLES', access.authorities);
                commit('SET_MENUS', access.adminMenus);
                return true;
            } else {
                throw new Error('접근 가능한 관리 메뉴가 없습니다.');
            }

        });
    },
    logout: ({commit})=> {
        commit('CLEAR');
    }
}
const getters = {
    token: state => state?.token,
    username: state => state?.username || '',
    userid: state => state?.userid || '',
    roles: state => state?.roles,
    menus: state => state?.menus
}

const mutations = {
    SET_TOKEN: (state, token) => {
        setToken(token);
        state.token = token;
    },
    SET_REFRESH: (state, refresh) => {
        setRefresh(refresh);
    },
    SET_USERNAME: (state, username) => {
        state.username = username;
    },
    SET_USERID: (state, userId) => {
        state.userid = userId;
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles;
    },
    SET_MENUS: (state, menus) => {
        state.menus = menus;
    },
    CLEAR: (state) => {
        state.token = '';
        state.roles = [];
        state.username = '';
        state.userid = '';
        state.menus = '';
        removeToken();
    }

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
